import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { CartProvider } from "@/lib/cart";
import CustomerApp from "@/pages/CustomerApp";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import AdminDashboard from "@/pages/AdminDashboard";
import { AdminSignInPage, AdminSignUpPage } from "@/pages/AdminAuth";
import SplashScreen from "@/components/SplashScreen";

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <BrowserRouter>
        <ClerkAuthProvider>
          <CartProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<CustomerApp />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderConfirmation />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/sign-in/*" element={<AdminSignInPage />} />
              <Route path="/admin/sign-up/*" element={<AdminSignUpPage />} />
            </Routes>
          </CartProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
